export default {
  banner: {
    title: "身份自动化",
    subtitle:
      "Authing 身份自动化平台提供了一套 PaaS 化编排工具，能帮助企业灵活实现身份数据与身份业务的自动化治理，自定义安全高效的身份生命周期管理。",
    data1: "满足复杂管理需求",
    data2: "减低重复建设成本",
    data3: "提升数据同步效率",
    data4: "把控流程执行结果",
    bg: "identify-automation-banner.png",
  },
  identifyReason: {
    title: "为什么企业需要自动化的管理身份？",
    subtitle1:
      "当企业规模扩张，应用数量增多，各系统身份数据不互通，企业内部身份数据从上游流转到下游，往往是繁琐、低效、滞后的。",
    subtitle2: "若以「割裂的数据」作为基础，将影响上层业务管理的效率和安全。",
    tab1: "自动化身份管理",
    tab2: "非自动化身份管理",
    bg1:
      "https://files.authing.co/authing-website/identify-automation-1-zh.png",
    bg2:
      "https://files.authing.co/authing-website/identify-automation-2-zh.png",
  },
  identifyEvent: {
    title: "基于「事件驱动」，简化复杂的身份治理流程",
    subtitle1: "一个流程，将繁琐的操作一步到位",
    subtitle2: "一次设置，自动完成多应用的数据同步和身份管理",
    descript1:
      "试想下，如果一个员工入职，从入职申请到完成审批，在各系统中新增人员、开启相应权限，需要涉及多少人、应用、步骤和时间？",
    descript2:
      "Authing 身份自动化平台基于「事件驱动」，企业仅需一次设置，即可自动地完成多个应用的数据同步和身份管理。",
    descript3:
      "以前述的情境为例，新员工入职后，触发了入职审批流程。管理员完成审批后，系统会在各应用系统目录中新增成员，自动开启相应权限，并发送邮件通知——将繁琐的操作一步到位，在提升效率的同时，降低人为操作导致的安全风险。",
  },
  identifyLayout: {
    title: "丰富的模版+灵活的编排能力，创建流程更高效",
    subtitle1:
      "Authing 预集成 400 款应用，封装近 80 个自动化身份管理模版，能帮助企业快速实现上下游身份数据的同步和供给。",
    subtitle2:
      "此外，Authing 也提供强大的数据处理（ETL）能力和灵活的流程控制能力，满足企业复杂的业务流程需求。",
    item1: {
      title: "飞书上游全量数据同步",
      subtitle:
        "拉取飞书用户列表和部门列表，自动进行部门和用户的创建/更新/删除",
    },
    item2: {
      title: "Windows AD 上游全量数据同步",
      subtitle:
        "拉取 AD 用户列表和部门列表，自动进行部门和用户的创建/更新/删除",
    },
    item3: {
      title: "企业微信上游全量数据同步",
      subtitle:
        "拉取企微用户列表和部门列表，自动进行部门和用户的创建/更新/删除",
    },
    item4: {
      title: "钉钉上游全量数据同步",
      subtitle:
        "拉取钉钉用户列表和部门列表，自动进行部门和用户的创建/更新/删除",
    },
    item5: {
      title: "LDAP 上游全量数据同步",
      subtitle:
        "拉取 LDAP 用户列表和部门列表，自动进行部门和用户的创建/更新/删除",
    },
    item6: {
      title: "LDAP 上游增量数据同步-部门创建",
      subtitle: "选择触发器，进行数据转换，对比部门数据后自动创建部门",
    },
    item7: {
      title: "Moka 上游增量数据同步-部门更新",
      subtitle: "选择触发器，进行数据转换，对比部门数据后自动更新部门",
    },
  },
  identifyLog: {
    title: "全量日志+全局视图，执行情况更可控",
    subtitle: "第一时间收到告警信息，快速定位问题、及时进行修正。",
    subtitle2: "打破黑盒状态，合理预期执行结果",
    descript1:
      "基于用户配置，自动计算生成身份数据视图，清晰展现身份数据的业务关系。",
    descript2:
      "提供运行日志，方便企业查看每个节点的执行状态、耗时、输入输出参数等，便于进行调试。",
    descript3: "提供同步历史，用于确认同步内容和结果的准确性。",
    descript4:
      "提供监控日志，记录运行失败的节点日志，并在此基础上对异常结果进行告警。",
  },
  identifyCustomer: {
    item1: {
      title: "某知名光学系统研发公司",
      descript1:
        "专注于精密光学系统的研发与制造，包括光学系统设计与优化、光学表面加工等。",
      subtitle: "自动化通知，让审批流程更快速",
      descript2:
        "为保障研发实验室的数据安全、网络安全、身份安全，并简化消息通知/待办整合的工作，我们通过 Authing 统一身份认证，并建立身份自动化引擎，将各个应用系统的消息通知推送至代办审批模块，方便员工快速、安全地完成日常办公。",
    },
    item2: {
      title: "某世界 500 强饮料商",
      descript1: "拥有全球 48% 市场占有率，在 200 个国家拥有 160 种饮料品牌。",
      subtitle: "自动化同步，让数据流转更高效",
      descript2:
        "通过 Authing 集成上游身份源，我们只需在一个系统中录入、修改、删除员工信息，即可将数据实时同步至下游多个应用，方便我们管理 20000+ 员工的身份数据，减少权限开通和回收的滞后，提高员工生命周期管理的流转效率。",
    },
    item3: {
      title: "某国内头部证券公司",
      descript1:
        "业务涵盖证券经纪、证券投资咨询、证券交易、证券投资活动有关的财务顾问等。",
      subtitle: "自动化分权，让运维管理更合规",
      descript2:
        "我们原有的 IDM 系统建设多年，部门和用户数量逐年增加，不再符合信创合规，也难以支撑业务需求。使用 Authing 建设身份自动化系统后，通过数据库和 API 的调取自动进行数据同步和权限分配，我们能够更好地兼顾身份管理的安全和效率。",
    },
  },
};
